import { formatQuantity } from "@common/utils/string";
import StorageUsageGraph from "./UsageGraph";
import { ManageAddOnLink } from "@components/account/plan/ManageAddOns/ManageAddOns.components";
import { AddOnCard } from "@addons/components/AddOnCard";
import { IAddOnSlotProps, IPrepaidAddOnDescriptor } from "../types";
import { prepaidTotal } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IPrepaidAddOnDescriptor>) {
  const { subscribed, purchase, canChangeSubscription, isYearly } = ctx;

  const manageSubscriptionLink = canChangeSubscription && (
    <ManageAddOnLink
      hasAddOn={!!subscribed}
      href={`/account/${purchase.id}/storage`}
    />
  );

  return (
    <AddOnCard
      isYearly={isYearly}
      productType="dwh"
      title={ctx.title}
      detail={
        subscribed
          ? `${formatQuantity(subscribed.prepaid_units)} stored rows`
          : null
      }
      price={prepaidTotal(ctx)}
      description="Start exploring your data right away by adding an easy, secure place to store your data from uploaded CSVs and spreadsheets."
      usage={subscribed && <StorageUsageGraph addOn={ctx} />}
      extra={manageSubscriptionLink}
    />
  );
}
